import { LabFeatureFlags } from 'constants/lab'
import { useAppSelector } from 'hooks/reduxHooks'
import { isLabSiteTakeoverPayload } from 'lib/lab/dynamicPayload'

/**
 * Hook-free variant so takeover config lookup and tests can share the same Lab payload access path.
 * This version is for use in SSR.
 */
export function getSiteTakeoverTheme(state: App.State): App.LabSiteTakeoverPayload | undefined {
  const enableSiteTakeover = state.system.features.labFlags[LabFeatureFlags.enableSiteTakeover]

  // TODO: Implement preview mode for site takeovers.
  if (!enableSiteTakeover?.enabled || !isLabSiteTakeoverPayload(enableSiteTakeover.value)) {
    return undefined
  }

  return enableSiteTakeover.value
}

export function useSiteTakeoverTheme(): App.LabSiteTakeoverPayload | undefined {
  return useAppSelector(getSiteTakeoverTheme)
}
